import { useNavigate } from 'react-router-dom';

const useEscalation = () => {
    const navigate = useNavigate();

    const escalationStorageListener = (url: string, extraData?: Record<string, any>) => {
        window.addEventListener('storage', (event) => {
            if (event.key === 'obd' && event.newValue) {
                try {
                    const data = JSON.parse(event.newValue);
                    if (data && data.type === 'obd') {
                        navigate(url, {
                            state: extraData,
                        });
                        localStorage.removeItem('obd');
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        });
    };

    return { escalationStorageListener };
};

export default useEscalation;
